import { render, staticRenderFns } from "./TransferBasket.vue?vue&type=template&id=36316278&scoped=true"
import script from "./TransferBasket.vue?vue&type=script&lang=js"
export * from "./TransferBasket.vue?vue&type=script&lang=js"
import style0 from "./TransferBasket.vue?vue&type=style&index=0&id=36316278&prod&lang=scss&scoped=true"
import style1 from "./TransferBasket.vue?vue&type=style&index=1&id=36316278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36316278",
  null
  
)

export default component.exports